"use client";

import { Backdrop } from "@mui/material";
import { TOP_NAV_Z_INDEX } from "./GlobalNav";
import { createContext, useContext, useState } from "react";

interface PageBackdropContext {
  setBackdropOpen: (open: boolean) => void;
}

const pageBackdropContext = createContext<PageBackdropContext | undefined>({
  setBackdropOpen: () => {
    throw new Error("setBackdropOpen not implemented");
  },
});

export function PageBackdropProvider({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const [backdropOpen, setBackdropOpen] = useState(false);
  const contextValue: PageBackdropContext = {
    setBackdropOpen,
  };

  return (
    <pageBackdropContext.Provider value={contextValue}>
      {children}
      <Backdrop
        open={backdropOpen}
        onClick={() => setBackdropOpen(false)}
        sx={{ zIndex: TOP_NAV_Z_INDEX }}
      />
    </pageBackdropContext.Provider>
  );
}

export function usePageBackdrop() {
  const context = useContext(pageBackdropContext);
  if (!context) {
    throw new Error(
      "usePageBackdrop must be used within a PageBackdropProvider"
    );
  }
  return context;
}
